import { Card } from '@/components/ui/card';

export const GlobalIndicators = ({ stats }) => {
  const indicators = stats ? [
    { label: 'Total', value: stats.total_publicaciones || 0, colorClass: 'text-foreground', bgClass: 'bg-foreground/10', borderClass: 'border-foreground/20' },
    { label: 'Activas', value: stats.publicaciones_activas || 0, colorClass: 'text-blue-500', bgClass: 'bg-blue-500/10', borderClass: 'border-blue-500/20' },
    { label: 'Vencidas', value: stats.publicaciones_vencidas || 0, colorClass: 'text-red-500', bgClass: 'bg-red-500/10', borderClass: 'border-red-500/20' },
    { label: 'En Espera', value: stats.publicaciones_en_espera || 0, colorClass: 'text-yellow-500', bgClass: 'bg-yellow-500/10', borderClass: 'border-yellow-500/20' },
    { label: 'Adjudicadas', value: stats.lotes_adjudicados || 0, colorClass: 'text-emerald-500', bgClass: 'bg-emerald-500/10', borderClass: 'border-emerald-500/20' },
    { label: 'No Adj.', value: stats.publicaciones_no_adjudicadas || 0, colorClass: 'text-slate-500', bgClass: 'bg-slate-500/10', borderClass: 'border-slate-500/20' }
  ] : [];

  if (!stats) return null;

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 -mt-6 relative z-10 mb-6">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 lg:gap-4">
        {indicators.map((ind, idx) => (
          <Card key={idx} className={`bg-card/90 backdrop-blur-sm border shadow-md flex flex-col items-center justify-center py-4 px-2 transition-transform hover:scale-105 ${ind.borderClass}`}>
            <div className={`text-xs sm:text-sm font-bold uppercase tracking-wider mb-2 text-center flex items-center gap-1.5 ${ind.colorClass}`}>
              <div className={`w-2 h-2 rounded-full ${ind.bgClass.split(' ')[0].replace('/10', '')}`} style={{ backgroundColor: 'currentColor' }} />
              {ind.label}
            </div>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground">
              {ind.value}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
